import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useStore } from "../helpers";
import { useParams } from "react-router-dom";

export const useGetFullProject = () => {
  const rootStore = useStore();
  const { projectid } = useParams();
  const { projectStore } = rootStore;

  const { data, isLoading, error, isError, refetch } = useQuery({
    queryKey: ["full-project", projectid],
    queryFn: async () => {
      // Fetch the data without updating store during render
      const payload = {
        projectid: parseInt(projectid),
      };
      const response = await rootStore.api.post(
        "project/getfullproject",
        payload
      );
      return response.data;
    },
    refetchOnWindowFocus: false,
    enabled: !!projectid,
    staleTime: 5 * 60 * 1000, // Cache for 30 minutes - project data doesn't change frequently
    cacheTime: 10 * 60 * 1000, // Keep in cache for 60 minutes
  });

  // Update store in useEffect to avoid updating during render
  useEffect(() => {
    if (data) {
      projectStore.dehydrate_project(data);
    }
  }, [data, projectStore]);

  return { data, isLoading, error, isError, refetch };
};
